import { cache } from '@/utils/cacheManager'

export class ContainerNewUtil {
  static refContainersNo(job) {
    if (!job.containers || !job.seaEQ) {
      return
    }
    for (const c of job.containers) {
      for (const seaEQ of job.seaEQ) {
        if (seaEQ.eqType === c.eqType && seaEQ.eqSize === c.eqSize) {
          if (!c.containerNo) {
            c.containerNo = seaEQ.containerNo
            c.isDirty = true
          }
          if (!c.sealNo) {
            c.sealNo = seaEQ.sealNo
            c.isDirty = true
          }
        }
      }
    }
  }

  /**
   * 主票装箱后，小票内件毛体变更，自动更新装箱信息
   */
  static SyncContainerQwcSynJob(job, usage) {
    const expression = parseInt(cache.config.get('ContainerUpdateJobQCW'))
    if (usage === null || job === null) return
    if (expression === 1) {
      this.containerQwcSynJob(job, usage)
    }
  }

  /**
   * 装箱同步Job
   */
  static containerQwcSynJob(job, usage) {
    if (usage.quantity > 0) {
      job.quantityContract = usage.quantity
    }
    if (usage.weight > 0) {
      job.weightContract = usage.weight
    }
    if (usage.cubage > 0) {
      job.cubageContract = usage.cubage
    }
  }
}
